// Toast UI 2.x drives its WYSIWYG pane with Squire, which rewrites pasted inline colour
// and font styling into classed spans. See the `classNames` config in
// node_modules/@toast-ui/editor/dist/toastui-editor.js:
//   { colour: 'colour', fontFamily: 'font', fontSize: 'size', highlight: 'highlight' }
// Markdown cannot express those spans, so getMarkdown() passes them straight through as
// raw inline HTML and we end up storing markup in a Markdown-only column.
//
// Squire runs its cleanup pass BEFORE firing willPaste, so by the time we see the
// fragment the classes are already applied. We strip both the classes Squire produces
// and the style properties it derives them from, which keeps this correct even if that
// ordering changes.
const PRESENTATIONAL_CLASSES = ['colour', 'font', 'size', 'highlight']
const PRESENTATIONAL_STYLES = ['color', 'background-color', 'font-family', 'font-size']

// Replace an element with its own children, preserving text and any nested formatting
// (<b>, <i>, links) that markdown *can* represent.
function unwrap(element) {
    const parent = element.parentNode
    if (!parent) return
    while (element.firstChild) {
        parent.insertBefore(element.firstChild, element)
    }
    parent.removeChild(element)
}

export function stripPresentationalMarkup(fragment) {
    if (!fragment || typeof fragment.querySelectorAll !== 'function') return fragment

    for (const element of [...fragment.querySelectorAll('[style]')]) {
        for (const property of PRESENTATIONAL_STYLES) {
            element.style.removeProperty(property)
        }
        if (!element.getAttribute('style')) element.removeAttribute('style')
    }

    for (const element of [...fragment.querySelectorAll('span')]) {
        element.classList.remove(...PRESENTATIONAL_CLASSES)
        if (!element.getAttribute('class')) element.removeAttribute('class')
        // A span carrying no attributes says nothing markdown can use.
        if (!element.attributes.length) unwrap(element)
    }

    return fragment
}
